import Noschedule from './Noschedule.vue';

export default Noschedule;



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/tabs/schedule/components/noschedule/index.ts